import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {FontSizeService} from 'src/app/services/font-size.service';
import {V3ExamSession, V3ExamSessionPart} from "../../model/v3/cspa";

@Component({
    selector: 'app-exam-start',
    templateUrl: './exam-start.component.html',
    styleUrls: ['./exam-start.component.scss'],
    standalone: false
})
export class ExamStartComponent implements OnInit, OnDestroy {
  @Input() session: V3ExamSession
  @Input() sessionParts: V3ExamSessionPart[] = []
  @Input() isSampleExam: boolean

  constructor(private route: ActivatedRoute,
              private router: Router,
              public fontSizeService: FontSizeService
  ) {
  }

  ngOnInit(): void {
    this.fontSizeService.setFromLocalStorage()
  }

  ngOnDestroy(){
    this.fontSizeService.setToDefault()
  }

  startExamSessionPart() {
    this.router.navigate(
      ['part/1/1'],
      {
        relativeTo: this.route,
        queryParamsHandling: 'merge'
      }
    ).then()
  }

  getChapter() {
    return this.session?.chapterName
  }
}
